import './App.css';
import RainforestRescue from './RainforestRescue';

function App() {
  return <RainforestRescue />;
}

export default App;
